export default __webpack_public_path__ + "static/media/Small.ca5e19e0.svg";